import React, { Fragment, useState } from 'react';
import {
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowController,
    ShowView,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    FormDataConsumer,
    ArrayInput,
    SimpleFormIterator,
    ImageField,
    ArrayField,
    BooleanField,
    BooleanInput,
    ImageInput,
    SelectArrayInput,
    NumberInput,
    NumberField,
    ReferenceInput,
    AutocompleteInput,
    useNotify,
    Toolbar,
    SaveButton,
    ReferenceField,
    Show,
    TabbedForm,
    FormTab,
} from 'react-admin';

import client from '../common/client';
import { Button, Box, CircularProgress, CardContent, CardActions, CardHeader, Card, Grid } from '@mui/material';
import { Stack } from '@mui/material';
import { useParams } from 'react-router-dom';

import Help from '../component/Help'
import JavascriptInput from '../component/JavascriptInput'

const ResourceTitle = ({ record }) => {
    return <span>Resource {record ? `"${record.name}"` : ''}</span>;
};

const EditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const ResourceFilter = props => (
    <Filter {...props}>
        <TextInput resettable label="Name" source="name" alwaysOn />
    </Filter>
);

export const ResourceList = props => {
    return (
        <List title="Resource" {...props} filters={<ResourceFilter />}
            exporter={false}
            sort={{ field: 'seq', order: 'ASC' }}
            perPage={100}
        >
            <Datagrid rowClick='show'>
                <TextField label="ID" source="id" />
                <TextField label="Sequence" source="seq" />
                <TextField label="Name" source="name" />
                <TextField label="Menu Name" source="menu_name" />
                <EditButton />
            </Datagrid>
        </List>
    )
};

const required = (message = 'Required') =>
    value => value ? undefined : message;
const maxLength = (max, message = (max + '자 이하로 입력해주세요')) =>
    value => value && value.length > max ? message : undefined;
const validateName = [required(), maxLength(15)];
const validateRequire = [required()];

export const TypeList =
    [
        { id: 'text', name: 'Text' },
        { id: 'date', name: 'Date' },
        { id: 'number', name: 'Number' },
        { id: 'bool', name: 'Boolean' },
        { id: 'reference', name: 'Reference' },
        { id: 'image', name: 'Image(s3)' },
        { id: 'mp4', name: 'Mp4(s3)' },
        { id: 'file', name: 'File(s3)' },
        { id: 'select', name: 'Select' },
        { id: 'array', name: 'Array' },
        { id: 'divider', name: 'Divider(UI)' },
        { id: 'showlist', name: 'ShowList' },
        { id: 'editor', name: 'Editor' },
    ]

const getBoxByType = (scopedFormData, getSource) => {
    if (scopedFormData && scopedFormData.type == 'image')
        return (
            <Box>
                <BooleanInput label="Required" source={getSource('require')} defaultValue={true} />
                <BooleanInput label="Private S3" source={getSource('private')} defaultValue={false} />
                <BooleanInput label="Avatar" source={getSource('avatar')} defaultValue={false} />
            </Box>
        )
    else if (scopedFormData && scopedFormData.type == 'file')
        return (
            <Box>
                <BooleanInput label="Private S3" source={getSource('private')} defaultValue={false} />
            </Box>
        )
    else if (scopedFormData && scopedFormData.type == 'reference')
        return (
            <Stack spacing={1}>
                <BooleanInput label="Required" source={getSource('require')} defaultValue={true} />
                <TextInput resettable label="Reference Entity" source={getSource('reference_entity')} validate={validateRequire} />
                <TextInput resettable label="Reference Label" source={getSource('reference_name')} validate={validateRequire} />
                
                <ArrayInput label="Filter" source={getSource('reference_filter_list')} >
                    <SimpleFormIterator>
                        <TextInput resettable label="Query" source={'query'} />
                        <TextInput resettable label="Value ex)'value' or property" source={'value'} />
                    </SimpleFormIterator>
                </ArrayInput>
            </Stack>
        )
    else if (scopedFormData && scopedFormData.type == 'text')
        return (<Box>
            <Box>
                <BooleanInput label="Required" source={getSource('require')} defaultValue={true} />
                <BooleanInput resettable label="Multiline" source={getSource('multiline')} />
            </Box>
        </Box>)
    else if (scopedFormData && scopedFormData.type == 'date')
        return (<Box>
            <Box>
                <BooleanInput label="Required" source={getSource('require')} defaultValue={true} />
                <BooleanInput label="Show Time" source={getSource('date_show_time')} defaultValue={true} />
                <TextInput resettable label="Format" source={getSource('date_format')} />
            </Box>
        </Box>)
    else if (scopedFormData && scopedFormData.type == 'bool')
        return (<Box>
            {/* <Box>
                <BooleanInput resettable label="Inline Edit in List " source={getSource('inline_edit')} />
            </Box> */}
        </Box>)
    else if (scopedFormData && scopedFormData.type == 'number')
        return (<Box>
            <Box>
                <NumberInput resettable label="min" source={getSource('min')} />
            <Box>
            </Box>
                <NumberInput resettable label="max" source={getSource('max')} />
            </Box>
        </Box>)
    else if (scopedFormData && scopedFormData.type == 'select')
        return (<Box>
            <BooleanInput label="Required" source={getSource('require')} defaultValue={true} />
            <TextInput validate={validateRequire} fullWidth resettable label="Select List Key ex)1,2" source={getSource('select_list_key')} />
            <TextInput validate={validateRequire} fullWidth resettable label="Select List Value ex)name1,name1" source={getSource('select_list_value')} />
            <TextInput sx={{ width: '300px' }} label="Condition ex)name=='aaa'" source={'condition'} defaultValue={''} />
            <ArrayInput label="More Depth" source={getSource('depth')} >
                <SimpleFormIterator>
                    <TextInput validate={validateRequire} fullWidth resettable label="Property Name" source={'name'} />
                    <TextInput validate={validateRequire} fullWidth resettable label="Label" source={'label'} />
                    <TextInput resettable label="Default Value" source={'default'} />
                    <TextInput validate={validateRequire} fullWidth resettable label="Parent Key ex)1,2" source={'select_list_parent'} />
                    <TextInput validate={validateRequire} fullWidth resettable label="Select List Key ex)1,2" source={'select_list_key'} />
                    <TextInput validate={validateRequire} fullWidth resettable label="Select List Value ex)name1,name1" source={'select_list_value'} />
                </SimpleFormIterator>
            </ArrayInput>)
        </Box>)
    else if (scopedFormData && scopedFormData.type == 'array')
        return (
            <ArrayInput label="List" source={getSource('array_list')} >
                <SimpleFormIterator>
                    <TextInput resettable label="Property Name" source={'name'} validate={validateRequire} />
                    <TextInput resettable label="Label" source={'label'} validate={validateRequire} />
                    <SelectInput resettable label="Type" source={'type'} defaultValue="text" choices={TypeList} />
                    <TextInput sx={{ width: '300px' }} label="Condition ex)name=='aaa'" source={'condition'} defaultValue={''} />
                    <FormDataConsumer>
                        {({ formData, scopedFormData, getSource, ...rest }) => {
                            return getBoxByType(scopedFormData, getSource)
                        }}
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>)
    else
        return (<Box></Box>)
}

export const ResourceCreate = props => (
    <Create title={<ResourceTitle />} {...props} mutationMode='pessimistic'>
        <TabbedForm redirect="edit">
            <FormTab label="UI">
                <Box mt={1}><Help title="Resource Overview" type="button" /></Box>
                <TextInput resettable label="Resource Name" source="name" validate={validateRequire} />
                <BooleanInput resettable label="Hide" source="hide"  defaultValue={false} />
                <TextInput resettable label="Menu Name" source="menu_name" validate={validateRequire} />
                <TextInput resettable label="Menu Icon Name(Material)" source="menu_icon" validate={validateRequire} />
                <NumberInput resettable label="Sequence" source="seq" validate={validateRequire} defaultValue={10}/>
                <TextInput resettable label="Key Colunm" source="key" defaultValue={'id'} validate={validateRequire} />
                <BooleanInput resettable label="Show [Id] Field In <List> and <Show>" source="show_id" defaultValue={true} />
                <BooleanInput label="List" source="list" defaultValue={true} />
                <BooleanInput label="Create" source="create" defaultValue={false} />
                <BooleanInput label="Edit" source="edit" defaultValue={false} />
                <BooleanInput label="Show" source="show" defaultValue={true} />
                <BooleanInput label="Hard Delete" source="delete" defaultValue={true} />
                <BooleanInput label="Soft Delete" source="soft_delete" defaultValue={false} />

                <ArrayInput label="Property" source="property" >
                    <SimpleFormIterator inline>
                        <FormDataConsumer>
                            {({ formData, scopedFormData, getSource, ...rest }) => (
                                <Box>
                                    <Box>
                                        <SelectInput resettable label="Type" source={getSource('type')} defaultValue="text" choices={TypeList} />
                                    </Box>

                                    {scopedFormData && scopedFormData.type != 'divider' && (
                                        <Box>
                                            <TextInput resettable label="Property Name" source={getSource('name')} validate={validateRequire} />
                                        </Box>
                                    )}
                                    <Box>
                                        <TextInput resettable label="Label" source={getSource('label')} validate={validateRequire} />
                                    </Box>

                                    {scopedFormData && scopedFormData.type != 'divider' && (
                                        <Box>
                                            <TextInput resettable label="Default Value" source={getSource('default')} />
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </FormDataConsumer>


                        <FormDataConsumer>
                            {({ formData, scopedFormData, getSource, ...rest }) => (
                                <Box>
                                    {scopedFormData.type != 'divider' && (
                                        <Box>
                                            <BooleanInput label="List" source={getSource('list')} defaultValue={true} />
                                            <BooleanInput label="Search" source={getSource('search')} defaultValue={false} />
                                            <BooleanInput label="Create" source={getSource('create')} defaultValue={false} />
                                            <BooleanInput label="Edit" source={getSource('edit')} defaultValue={false} />
                                            <BooleanInput label="Show" source={getSource('show')} defaultValue={true} />
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </FormDataConsumer>

                        <FormDataConsumer>
                            {({ formData, scopedFormData, getSource, ...rest }) => {
                                return getBoxByType(scopedFormData, getSource)
                            }}
                        </FormDataConsumer>

                    </SimpleFormIterator>
                </ArrayInput>
            </FormTab>

            <FormTab label="Property Raw">
                <JavascriptInput fullWidth={true} height='600px' label="Map" source="raw" />
            </FormTab>
        </TabbedForm>
    </Create>
);

export const ResourceEdit = props => (
    <Edit redirect="edit" title={<ResourceTitle />} {...props} mutationMode='pessimistic'>
        <TabbedForm>
            <FormTab label="UI">
                <Box mt={1}><Help title="Resource Overview" type="button" /></Box>
                <TextInput resettable label="Resource Name" source="name" validate={validateRequire} />
                <BooleanInput resettable label="Hide" source="hide"  defaultValue={false} />

                <FormDataConsumer>
                    {({ formData, scopedFormData, getSource, ...rest }) => (
                        <Box>
                            {formData && !formData.hide && <TextInput resettable label="Menu Name" source="menu_name" validate={validateRequire} />}
                        </Box>
                    )}
                </FormDataConsumer>
                <FormDataConsumer>
                    {({ formData, scopedFormData, getSource, ...rest }) => (
                        <Box>
                            {formData && !formData.hide && <TextInput resettable label="Menu Icon Name(Material)" source="menu_icon" validate={validateRequire} />}
                        </Box>
                    )}
                </FormDataConsumer>
                <TextInput resettable label="Key Colunm" source="key" defaultValue={'id'} validate={validateRequire} />
                <NumberInput resettable label="Sequence" source="seq" validate={validateRequire} defaultValue={10}/>
                <BooleanInput resettable label="Show [Id] Field In <List> and <Show>" source="show_id" defaultValue={true} />
                <BooleanInput label="List" source="list" defaultValue={true} />
                <BooleanInput label="Create" source="create" defaultValue={false} />
                <BooleanInput label="Edit" source="edit" defaultValue={false} />
                <BooleanInput label="Show" source="show" defaultValue={true} />
                <BooleanInput label="Hard Delete" source="delete" defaultValue={true} />
                <BooleanInput label="Soft Delete" source="soft_delete" defaultValue={false} />

                <ArrayInput label="Property" source="property" >
                    <SimpleFormIterator inline>
                        <FormDataConsumer>
                            {({ formData, scopedFormData, getSource, ...rest }) => (
                                <Box>
                                    <Box>
                                        <SelectInput resettable label="Type" source={getSource('type')} defaultValue="text" choices={TypeList} />
                                    </Box>

                                    {!['divider', 'showlist'].includes(scopedFormData.type) && (
                                        <Box>
                                            <TextInput resettable label="Property Name" source={getSource('name')} validate={validateRequire} />
                                        </Box>
                                    )}

                                    {['showlist'].includes(scopedFormData.type) && (
                                        <Box>
                                            <TextInput resettable label="Entity Name" source={getSource('name')} validate={validateRequire} />
                                        </Box>
                                    )}

                                    <Box>
                                        <TextInput resettable label="Label" source={getSource('label')} validate={validateRequire} />
                                    </Box>

                                    {!['divider', 'showlist'].includes(scopedFormData.type) && (
                                        <Box>
                                            <TextInput resettable label="Default Value" source={getSource('default')} />
                                        </Box>
                                    )}

                                    {!['divider', 'showlist'].includes(scopedFormData.type) && (
                                        <Box>
                                            <TextInput sx={{ width: '300px' }} label="Condition ex)name=='aaa'" source={getSource('condition')} defaultValue={''} />
                                        </Box>
                                    )}


                                </Box>
                            )}
                        </FormDataConsumer>


                        <FormDataConsumer>
                            {({ formData, scopedFormData, getSource, ...rest }) => (
                                <Box>
                                    {!['divider', 'showlist'].includes(scopedFormData.type) && (
                                        <Box>
                                            <BooleanInput label="List" source={getSource('list')} defaultValue={true} />
                                            <BooleanInput label="Search" source={getSource('search')} defaultValue={false} />
                                            <BooleanInput label="Create" source={getSource('create')} defaultValue={false} />
                                            <BooleanInput label="Edit" source={getSource('edit')} defaultValue={false} />
                                            <BooleanInput label="Show" source={getSource('show')} defaultValue={true} />
                                        </Box>
                                    )}
                                </Box>
                            )}
                        </FormDataConsumer>

                        <FormDataConsumer>
                            {({ formData, scopedFormData, getSource, ...rest }) => {
                                return getBoxByType(scopedFormData, getSource)
                            }}
                        </FormDataConsumer>

                    </SimpleFormIterator>
                </ArrayInput>
            </FormTab>

            <FormTab label="Property Raw" path="raw">
                <JavascriptInput fullWidth={true} height='600px' label="Map" source="raw" />
            </FormTab>
        </TabbedForm>
    </Edit>
);

export const ResourceShow = ({ ...props }) => {
    const { id } = useParams()
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const handleDeployToGithub = (e) => {
        setLoading(true)
        client.request_get(`/api/resource/backend/deploy/resource/${id}`).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Generate Success`);
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    return (
        <Show {...props} title={<ResourceTitle />}>
            <SimpleShowLayout>
                <TextField label="Name" source="name" />
                <Stack direction="row" spacing={1}>
                    <Button startIcon={loading && <CircularProgress size={24} />} variant="contained" color="secondary" onClick={handleDeployToGithub} disabled={loading}>
                        Deploy To Github</Button>
                    <Help />
                </Stack>

            </SimpleShowLayout>
        </Show>
    )
};
